import React from 'react';
var ScrollButton = function ScrollButton(_ref) {
  var button = _ref.button,
    last = _ref.last,
    setcurrentIndex = _ref.setcurrentIndex,
    currentIndex = _ref.currentIndex,
    mobileFlag = _ref.mobileFlag;
  var scrollTo = function scrollTo(isDown) {
    isDown ? setcurrentIndex(currentIndex + 1) : setcurrentIndex(currentIndex - 1);
  };
  var scrollToMobile = function scrollToMobile() {
    window.scrollTo(0, document.querySelector('.section-1.part-1').offsetHeight);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !mobileFlag ? /*#__PURE__*/React.createElement(React.Fragment, null, currentIndex != 0 && /*#__PURE__*/React.createElement("div", {
    className: "scroll-button sticky-downlink top",
    onClick: function onClick() {
      return scrollTo(false);
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: "disc-down"
  }, /*#__PURE__*/React.createElement("span", null, "\uE604"))), currentIndex != last && /*#__PURE__*/React.createElement("div", {
    className: "scroll-button sticky-downlink down",
    onClick: function onClick() {
      return scrollTo(true);
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: "disc-down"
  }, /*#__PURE__*/React.createElement("span", null, "\uE601")), button.link.content)) : /*#__PURE__*/React.createElement("div", {
    className: "scroll-button sticky-downlink down mobile",
    onClick: scrollToMobile
  }, /*#__PURE__*/React.createElement("a", {
    className: "disc-down"
  }, /*#__PURE__*/React.createElement("span", null, "\uE601"))));
};
export default ScrollButton;